import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {gqlBillingParty} from '../getBillingParty.api';
import {BillingParty} from '../../../graphql/billing_party.datatypes';

interface DeleteBillingPartyInput {
    id: number
}

interface DeleteBillingPartyData {
    deleteBillingParty: BillingParty
}

export const DELETE_GRUOP_MUTATION = gql`
    mutation deleteBillingParty($id: Int!) {
        deleteBillingParty(id: $id) {
            ${gqlBillingParty}
        }
    }
`;

export const deleteBillingParty = () => useMutation<DeleteBillingPartyData, DeleteBillingPartyInput>(
  DELETE_GRUOP_MUTATION,
  {
    update: updateCacheByType('BillingParty'),
  }
);

export default deleteBillingParty;